module.exports = __webpack_public_path__ + "media/components/app-store/static/ios-e2713a6bceb742a100a0daaefb28f736.svg";